import { render } from "./video.vue?vue&type=template&id=d8f494ac&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"

import "./video.vue?vue&type=style&index=0&id=d8f494ac&lang=less&scoped=true"
import "./video.vue?vue&type=style&index=1&id=d8f494ac&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8f494ac"]])

export default __exports__